import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/comics';

interface MangaCardProps {
  manga: Manga;
  rank?: number;
}

export default function MangaCard({ manga, rank }: MangaCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${manga.id}`}
      className="group block"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200 mb-3">
        <img
          src={manga.cover}
          alt={manga.title}
          title={`${manga.title} - 女神漫画排行榜热门精选`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
        />
        {rank && (
          <div className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center rounded-lg bg-primary-500 text-white text-xs font-bold">
            {rank}
          </div>
        )}
        <div className="absolute top-2 right-2">
          <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
            manga.status === '连载中'
              ? 'bg-accent-500/90 text-white'
              : 'bg-foreground-600/80 text-white'
          }`}>
            {manga.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-white text-xs line-clamp-2">{manga.description}</p>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
        {manga.title}
      </h3>
      <div className="flex items-center gap-2 mt-1">
        <span className="text-xs text-foreground-500">{manga.category}</span>
        <span className="text-xs text-foreground-400">·</span>
        <span className="text-xs text-foreground-500">{manga.latestChapter}</span>
      </div>
      <div className="flex items-center gap-3 mt-1">
        <div className="flex items-center gap-1">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
          <span className="text-xs text-foreground-600 font-medium">{manga.rating}</span>
        </div>
        <div className="flex items-center gap-1">
          <i className="ri-eye-line text-foreground-400 text-xs"></i>
          <span className="text-xs text-foreground-500">{formatViews(manga.views)}</span>
        </div>
      </div>
    </Link>
  );
}